<script setup lang="ts">
const { fileUrl } = useFiles();
const { data: globals } = await useGlobals();

const props = defineProps({
  variant: {
    type: String,
    default: 'dark',
    validator: (value: string) => ['light', 'dark'].includes(value),
  },
  color: {
    type: String,
    default: 'currentColor',
  },
});

const logo = computed(() => {
  const globalsValue = globals.value as unknown as Record<string, unknown> | undefined;
  if (import.meta.dev) {
    console.group('[Logo] globals diagnostic');
    console.log('globals present:', !!globalsValue);
    console.log('globals keys:', globalsValue ? Object.keys(globalsValue) : 'none');
    console.log('variant:', props.variant);
    console.log('logo_on_light_bg:', globalsValue?.logo_on_light_bg);
    console.log('logo_on_dark_bg:', globalsValue?.logo_on_dark_bg);
    console.groupEnd();
  }
  const id = props.variant === 'light'
    ? globalsValue?.logo_on_light_bg
    : globalsValue?.logo_on_dark_bg;
  if (!id) {
    if (import.meta.dev) console.warn('[Logo] No logo ID found — falling back to text logo. Check that globals loaded correctly at dev-server startup.');
    return null;
  }
  const url = id
  if (import.meta.dev) console.log('[Logo] resolved URL:', url);
  return url;
});
</script>

<template>
  <NuxtImg v-if="logo"
    :src="logo"
    alt="BVB General Contractors Building Your Success!"
    height="68"
    width="246"


    />
  <template v-else>
    <span class="font-display font-bold text-xl tracking-tight">
      <span class="text-primary-500">BVB</span>
      <span class="text-neutral-600 dark:text-neutral-300"> General Contractors</span>
    </span>
  </template>
</template>

<style>
.accent {
  fill: rgb(var(--color-primary-500));
}
</style>
